<div [class]="'theme-wrapper ' + (theme$ | async)">

  <mat-sidenav-container>

    <mat-sidenav #sidenav mode="push">
      <div class="branding"><img [src]="logo" [alt]="logo" />
        <span>{{ 'rpe.title.short' | translate}}</span>
      </div>
      <!--
        <mat-nav-list>
        <a mat-list-item *ngFor="let item of navigationSideMenu" (click)="sidenav.close()" [routerLink]="[item.link]"
          routerLinkActive="active">
          {{item.label | translate}}
        </a>
      </mat-nav-list>
    -->
    </mat-sidenav>

    <div class="wrapper">

      <div class="toolbar" [style.position]="(stickyHeader$ | async) ? 'fixed' : 'inherit'"
        [class.mat-elevation-z4]="(stickyHeader$ | async)">
        <mat-toolbar color="primary">
          <button mat-icon-button class="d-md-none" (click)="sidenav.open()">
            <fa-icon icon="bars"></fa-icon>

          </button>

          <span routerLink="/main/landing" class="branding spacer center d-inline d-sm-none">
            <img [src]="logo" [alt]="logo" /></span>
          <span routerLink="/main/landing" class="branding spacer center d-none d-sm-inline d-md-none"><img [src]="logo"
              [alt]="logo" /></span>
          <span routerLink="/main/landing" class="branding d-none d-md-inline"><img [src]="logo" [alt]="logo" /></span>
          <span class="spacer center d-inline d-sm-inline d-md-inline"></span>


          <div *ngIf="(isAuthenticated$ | async)">
            <ng-container *ngIf="currentEmpresa">
              <button mat-button mat-stroked-button color="accent" routerLink="../empresas/mi-empresa">
                {{ currentEmpresa?.nombre }}
              </button>
              <!--<button type="button" mat-icon-button matTooltip="Cambiar empresa">
                <mat-icon>
                  <fa-icon icon="arrows-rotate"></fa-icon>
                </mat-icon>
              </button> -->
              <a mat-raised-button class="actions-main" color="primary" routerLink="../empresas/mis-empresas"
                *ngIf="cantidadEmpresas > 1"> Cambiar empresa </a>
            </ng-container>
          </div>

          <!--<button mat-button mat-stroked-button color="accent" *ngIf="!(isAuthenticated$ | async)"
            (click)="onLoginClick()">
            {{ 'rpe.menu.login' | translate }}
          </button> -->

          <ng-container *ngIf="persona$ | async as persona">
            <button *ngIf="(isAuthenticated$ | async)" mat-button [matMenuTriggerFor]="toolbarUserMenu">
              <span class="mRight">{{persona.nombre_completo}}</span>
              <fa-icon style="margin-left: 10px;" icon="user-circle"></fa-icon>
            </button>

            <mat-menu #toolbarUserMenu="matMenu">
              <button mat-menu-item (click)="onRedirectToProfile()">
                <mat-icon>
                  <fa-icon icon="user-circle"></fa-icon>
                </mat-icon>
                <span>{{ 'rpe.menu.profile' | translate }}</span>
              </button>
              <button mat-menu-item (click)="onLogoutClick()">
                <mat-icon>
                  <fa-icon icon="power-off"></fa-icon>
                </mat-icon>
                <span>{{ 'rpe.menu.logout' | translate }}</span>
              </button>
            </mat-menu>
          </ng-container>
        </mat-toolbar>
      </div>

      <div class="content" [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig?.data?.title">
        <router-outlet #o="outlet"></router-outlet>
      </div>

      <div class="footer" [ngClass]="(envName === 'DEV' || envName === 'TEST') ? 'bg-red' : ''">
        <div class="row">
          <div class="col-12 signature">
            &#169; <span class="year">{{year}}</span> - GIS514 |
            <br class="d-block d-sm-none">
            Versión: {{version}} <span *ngIf="!isProd">[{{envName}}]</span>
          </div>
        </div>
      </div>

    </div>

  </mat-sidenav-container>

</div>
